import { Routes, Route } from 'react-router-dom';
import VendorReferralsOverview from './VendorReferralsOverview';

interface VendorReferralsProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorReferrals({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorReferralsProps) {
  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route path="/" element={<VendorReferralsOverview {...props} />} />
    </Routes>
  );
}

export default VendorReferrals;
